import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import {
  Route,
  Redirect,
  Link,
  useLocation,
  useHistory,
} from "react-router-dom";
import { Layout, Menu, Dropdown, Button, Select } from "antd";
import cookie from "react-cookies";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [cur, setCur] = useState("zh_CN");

  useEffect(() => {
    setCur(localStorage.getItem("i18nextLng"));
  }, [localStorage.getItem("i18nextLng")]);

  const changeLanguage = (key) => {
    i18n.changeLanguage(key);
    window.location.reload();
  };

  return (
    <div className="cont-header">
      <div className="logo">
        <img src={require("../../../assets/image/logo.jpg").default} />
      </div>

      <div className="action">
        <div className="action-item language">
          <div className="list">
            <Select
              value={cur}
              bordered={false}
              style={{ width: "120px", textAlign: "center" }}
              options={[
                {
                  label: "English",
                  value: "en",
                },
                {
                  label: "简体中文",
                  value: "zh_CN",
                },
              ]}
              onSelect={(key) => {
                // console.log(key);
                changeLanguage(key);
              }}
            />
          </div>
          {/* <div className="img">
            <img src={require("../../../assets/image/change.png").default} />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
